import { render, staticRenderFns } from "./ApplicationRecord.vue?vue&type=template&id=19b183ec&scoped=true&"
import script from "./ApplicationRecord.vue?vue&type=script&lang=js&"
export * from "./ApplicationRecord.vue?vue&type=script&lang=js&"
import style0 from "./ApplicationRecord.vue?vue&type=style&index=0&id=19b183ec&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19b183ec",
  null
  
)

export default component.exports